export default "__VITE_ASSET__DGDzwlOF__"